import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none" aria-hidden="true"><path fill="currentColor" d="M3.5 3.5a.2.2 0 0 0-.2.2v1h1.2V10h1.8V4.8h1.3v-1a.2.2 0 0 0-.2-.3h-4Zm4.4 1.7V10h.6l.3-1a.5.5 0 0 1 .2-.3.2.2 0 0 0 0-.3V6.8l-.2-.1a2.1 2.1 0 0 1 0-.6l.2-.4v-.4h.1l.4-.4h.1V5l.3-.2v-.2c0-.1 0-.3.2-.3h.4v.1a.1.1 0 0 0 .1.1l.2.2h.5V5h.8V5 3.7a.2.2 0 0 0-.1-.2H8.8a.2.2 0 0 0-.2.1l-.7 1.6Z"></path><path fill="currentColor" d="M10.2 9.9H9l.3-.7.2-.2.3-.4V8l.4.3v.3a49.4 49.4 0 0 0 0 1.2Zm2 0h-1.4v-1l.1-.4-.1-.5-.3-.5a12.1 12.1 0 0 0-.1-.3v-.3c.1 0 .2 0 .2-.2v-.3c.1-.1 0-.2 0-.2-.1 0 0 0 0 0 0-.1 0-.1 0 0a.7.7 0 0 0 .1 0h.5V6l.4-.8h.5v4.6Z"></path><path fill="currentColor" fill-rule="evenodd" d="M12.5 9.9V5.2h.7V5h-.7V3.7c0-.1 0-.2.2-.2h3.9s.2 0 .2.2v3.8a.2.2 0 0 1-.2.2H16l.7 2.2h-2l-.6-2.1v2h-1.7ZM15 4.8h-.8v1.6h.8V4.8Z" clip-rule="evenodd"></path><path fill="currentColor" d="M3.3 10.5v6.3h1.6v-3.1l1 3.1h1.6l-1-4.2 1-2.1H5.7L5 11.7v-1a.2.2 0 0 0-.2-.2H3.3Z"></path><path fill="currentColor" fill-rule="evenodd" d="M8.7 10.5 8 12.2v3.1l.5 1.5h3l.8-1.6v-4.7H8.7Zm1 1.3h.8v4h-.8v-4Z" clip-rule="evenodd"></path><path fill="currentColor" d="M12.8 10.5a.2.2 0 0 0-.2.2c.1 1.9.5 5.4 1 6.1h2.2c.6-1 1-4.8 1-6.1a.2.2 0 0 0-.3-.2h-1.4v2.1l-.4 1.2-.4-1.2v-2.1h-1.5Zm-2-5.6-.1-.1c-.1 0 0 0 0 0V5c-.1 0-.1 0 0 0h.2-.1Zm-.2.4h.1c0 .2 0 .1-.1 0Zm.5.2c0-.1 0 0 0 0V5.9h-.2v-.2a1 1 0 0 0 .2-.1Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
